import { createClient } from './createClient.js';
import { publicActions } from './decorators/public.js';
export function createPublicClient({ batch, chain, key = 'public', name = 'Public Client', transport, pollingInterval, }) {
    const client = {
        batch,
        ...createClient({
            chain,
            key,
            name,
            pollingInterval,
            transport,
            type: 'publicClient',
        }),
    };
    return {
        ...client,
        ...publicActions(client),
    };
}
//# sourceMappingURL=createPublicClient.js.map